import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import { supabase } from '../supabaseClient';

function Faith({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'faith',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Faith
            </h3>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Faith means we trust life.  Maybe we have faith because we trust in God, or maybe our highest self, or the divine orchestration. <br /> Whatever it is that gives us the permission slip to surrender to a higher power is what is right for us. <br /> Sometimes when we do not have Faith we can still access Hope.  Hope means we have not given up and wish for something more.  This is a very helpful state to being when we find ourselves suffering without something we feel we need or want.  Whenever we can get to the place where we feel it would be nice to have that thing I hope for, but I am ok without it too our vibration will be closer to the having of what we hoped for.   There does come a time when being hopeful can impede us.  This would be in cases where Faith would help us line up with what is hoped for.  Knowing that the divine orchestration has your back on your hope will allow you to be in a vibration that lines up with that version of your life.  
                    </p>
                </div>

                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Faith is not something we can give to another person.  Faith is a personal thing for each of us.  Understanding that Faith is a step up from Hope was the major lesson that I had around Faith.   I also came to see how Faith allowed me to Surrender my want to control, or know.  For me, Faith was not modeled to me or taught. No one told me about Faith.  I niavely stumbled into Faith and then it just proved that I was safe there.  That is how I came to trust life.  I just blindly leaped into it and it caught me.  
                    </p>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        In terms of Faith, we can look at it as what would I have if I did not have faith?  maybe hope? maybe the weight of the world on your shoulders.  Is Faith the ultimate surrender for the things we cannot control?  <br />  Here is what I came to around the topic of Control.  When we try to control something we are introducing FORCE and while sometimes we can effect change with force it will usually have some other Ill effect.  ENERGY does not respond well to force.  Instead, we set our intention, which is like an INTRODUCTION to the energy.. "Hi Energy(thing I used to control), how's about we go this way." If we pay attention we will see everything in the way of the energy going that way and have opportunity to clear each detractor. When we clear the contrary energy which can often be harbored in our own subconscious, the energy moves in the direction we intend.  It is a Co-creation.  Energy responds to the introduction we make to it..while the force we impede on it can have a backfire or unintended consequences. Energy likes to flow, is moving,  will show up in response to us, is us.   What do you think?  I think when we use these techniques we can allow ourselves to surrender without just floating through without direction in life.  
                    </p>
                </div>
            </div>
            {/* New Card with Embedded Video */}
            <div style={{
                width: '100%',
                maxWidth: '600px',
                border: '2px solid black',
                borderRadius: '10px',
                padding: '16px',
                textAlign: 'center',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                margin: '24px 0 0 0'
            }}>
                <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/CD3fF5ffJYA?si=-joYrxVSbfd7W0-e"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    style={{
                        borderRadius: '10px',
                        maxWidth: '100%',
                        minHeight: '200px'
                    }}
                ></iframe>
            </div>
            {/* Navigation Buttons */}
            <div
                className="faith-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >Back</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >Home</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={handleSaveProgress}
                >Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .faith-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Faith;
